import React from 'react';

const PageError = () => (
  <h1>PageError</h1>
);

export default PageError;
